<template>
  <div class=" w-full curve-item-wrap flex flex-col">
    <div class="flex flex-row items-center justify-between">
      <div class="text-left">
        <div class="main-color text-18px">{{ deviceType }}</div>
        <div class="third-color text-15px">{{ tagId }}</div>
      </div>
      <div class="text-right">
        <div class="third-color text-15px" v-for="(item,index) in curveCreateTime" :key="index">{{ item }}</div>
      </div>

    </div>

    <div class="mt-6">
      <HistoryCurve
          curve-color="#679AFF"
          :curve-line-color="[
             {offset:1,color:'rgba(0, 60, 255, 1)'},
             {offset:0.75,color:'rgba(108, 158, 255, 0.75)'},
             {offset:0,color:'rgba(255, 255, 255, 0)'}
          ]"
          :resistance="resistance"
          :max-power="maxPower"
          :power="power"/>
    </div>

    <div class="flex flex-row items-center gap-4 mt-6 ml-4 mr-4">
      <div v-if="showFavorite" class="flex-1 favorite-btn btn-size" @click="onFavoriteClicked">{{ favoriteText }}</div>
      <div class="flex-1 apply-btn btn-size" @click="onApplyClicked">Apply</div>
    </div>

  </div>
</template>


<script>
import HistoryCurve from "@/views/HistoryCurve.vue";

export default {
  name: "CurveItem",
  components: { HistoryCurve },
  props: {
    showFavorite: {
      type: Boolean,
      default: false
    },
    deviceType: {
      type: String,
      default: ""
    },
    tagId: {
      type: String,
      default: ""
    },
    createTime: {
      type: String,
      default: ""
    },
    power: {
      type: Array,
      default: () => {
        return [0, 0, 0, 0, 0, 0, 0, 0];
      }
    },
    resistance: {
      type: Number,
      default: 1.2
    },
    maxPower: {
      type: Number,
      default: 10
    },
    isFavorite: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onFavoriteClicked() {
      this.$emit("onFavorite");
    },
    onApplyClicked() {
      this.$emit("onApply");
    }
  },
  data() {
    return {};
  },
  computed: {
    favoriteText() {
      if (this.isFavorite === 0) {
        return "Favorite"
      }
      return "UnFavorite"
    },
    curveCreateTime() {
      const createTime = this.createTime;
      const result = createTime.split(" ");
      const time = result[result.length - 1];
      return [createTime.substring(0, createTime.length - time.length), time];
    }
  }
};
</script>


<style scoped lang="less">
.curve-item-wrap {
  border-radius: 12px;
  padding: 16px;
  background: white;
}

.btn-size {
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.favorite-btn {
  border-radius: 6px;
  border: 1px solid #BEBEBE;
  color: #333333;
}

.apply-btn {
  border-radius: 6px;
  background: #121212;
  color: white;
}
</style>